import {
  Component,
  ViewChild,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { ModalComponent } from "../../components/modal/modal.component";

@Component({
  selector: "lowy-approve-upload",
  template: `
    <lowy-modal #modal>
      <div class="form">
        <span class="link" (click)="modal.close()"
          ><i class="material-icons">keyboard_backspace</i>cancel</span
        >
        <div class="headline">Are You Sure?</div>
        <div class="subheading" *ngIf="isApprove">
          The items you are approving will be made available for all researchers
          in the application.
        </div>
        <div class="subheading" *ngIf="!isApprove">
          The items you are rejecting will be removed from your queue and no
          longer be available to view.
        </div>
        <div *ngIf="isApprove">
          <mat-form-field style="width:90%">
            <textarea
              maxlength="400"
              matInput
              placeholder="Approval Comments"
              [(ngModel)]="comments"
            ></textarea>
          </mat-form-field>
          <p>
            <i
              >Approval comment will be applied to all {{ count }} items being
              approved.</i
            >
          </p>
        </div>
        <div class="row">
          <div class="col-2">
            <button
              mat-button
              class="lowy-btn-std"
              *ngIf="isApprove"
              (click)="doApprove()"
            >
              approve
            </button>
            <button
              mat-button
              class="lowy-btn-std"
              *ngIf="!isApprove"
              (click)="doReject()"
            >
              reject
            </button>
          </div>
        </div>
      </div>
    </lowy-modal>
  `,
})
export class ApproveUploadComponent {
  @ViewChild("modal") modal: ModalComponent;

  @Output() approve: EventEmitter<any>;
  @Output() reject: EventEmitter<any>;

  public count: number;

  public comments: string;
  public isApprove: boolean;

  constructor() {
    this.approve = new EventEmitter();
    this.reject = new EventEmitter();
  }

  public open(isApprove: boolean, count?: number) {
    this.isApprove = isApprove;
    this.count = count;
    this.modal.open();
  }

  public doApprove() {
    this.approve.emit(this.comments);
    this.comments = "";
    this.modal.close();
  }

  public doReject() {
    this.reject.emit();
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/reports/approve-modal.component.ts